import React from "react";
import PropTypes from "prop-types";
import HourglassEmpty from "@mui/icons-material/HourglassEmpty";
import {spinAnimation} from "../../resources/styles/AnimationStyles";

const EmptySpinningHourglass = ({
  color = "primary",
  id = "empty-spinning-hourglass",
  fontSize,
  sx,
}) => <HourglassEmpty color={color} id={id} fontSize={fontSize} sx={{...sx, ...spinAnimation}} />;

EmptySpinningHourglass.propTypes = {
  color: PropTypes.string,
  id: PropTypes.string,
  fontSize: PropTypes.string,
  sx: PropTypes.object,
};

export default EmptySpinningHourglass;
